import { AdresPresentation, AuthContext, SettingsContext } from "adviesbox-shared";
import { FormikContextType, connect, getIn } from "formik";
import React, { InputHTMLAttributes, ReactElement, useContext, useRef } from "react";

import { AdresType } from "../../types";
import LabeledHdnKeuzelijst from "../hdn-keuzelijst/LabeledHdnKeuzelijst";
import getPostcodeInfo from "./get-postcode-info";

export type AdresProps = {
  readonly?: boolean;
  name: string;
  plaatsCaption?: string;
  landCaption?: string;
  metLand?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

const AdresInputComponent = ({
  readonly,
  name,
  formik,
  plaatsCaption,
  landCaption,
  metLand = true
}: AdresProps & { formik: FormikContextType<{}> }): ReactElement => {
  const { user } = useContext(AuthContext);
  const settings = useContext(SettingsContext);
  const adres = getIn(formik.values, name) as AdresType;

  let postcode = "";
  let huisnummer: number | null = null;
  let landCode = "";

  if (adres !== undefined) {
    postcode = adres.postcode.toUpperCase().replace(/\s/g, "");
    huisnummer = adres.huisnummer;
    landCode = adres.landCode;
  }

  const previousPostcodeHuisnummer = useRef({ postcode, huisnummer });

  async function postcodeHuisnummerChanged(): Promise<void> {
    const postcodeError = getIn(formik.errors, `${name}.postcode`) !== undefined;

    if (landCode === "NL" && adres.postcode && huisnummer && !postcodeError) {
      if (
        postcode === previousPostcodeHuisnummer.current.postcode &&
        huisnummer === previousPostcodeHuisnummer.current.huisnummer
      ) {
        return;
      }

      previousPostcodeHuisnummer.current = {
        postcode,
        huisnummer
      };

      const postcodeInfo = await getPostcodeInfo(user, settings, postcode, huisnummer);
      if (postcodeInfo) {
        if (postcodeInfo.postcode) {
          postcodeInfo.postcode = postcodeInfo.postcode.toUpperCase().replace(/\s/g, "");
        }

        if (
          postcodeInfo.huisnummer === previousPostcodeHuisnummer.current.huisnummer &&
          postcodeInfo.postcode === previousPostcodeHuisnummer.current.postcode
        ) {
          const currVal = getIn(formik.values, name);
          formik.setFieldValue(`${name}`, {
            ...currVal,
            plaats: postcodeInfo.plaats,
            straat: postcodeInfo.straat
          });
        }
      }
    }
  }
  return (
    <>
      <AdresPresentation
        landCode={landCode}
        name={name}
        onBlur={postcodeHuisnummerChanged}
        readonly={readonly}
        plaatsCaption={plaatsCaption}
      />
      {metLand && (
        <LabeledHdnKeuzelijst
          caption={landCaption ? landCaption : "Land"}
          name={`${name}.landCode`}
          keuzelijst="LandType"
          berichtSoortType="AX"
          readonly={readonly}
        />
      )}
    </>
  );
};

export const AdresInput = connect<AdresProps>(AdresInputComponent);
